import { Component } from 'react';
import { Button, Col, Input, Row } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import clone from 'lodash/clone';
import ColorPicker from '@src/containers/ColorPicker';

export type AffixMapItem = {
  value: string;
  text: string;
  color?: string;
};

/**
 * Map giá trị cột phụ thuộc → text prefix/suffix (+ màu tùy chọn)
 */
class AffixMapEditor extends Component<{
  value?: AffixMapItem[];
  onChange?: (val: AffixMapItem[]) => void;
}> {
  state = {
    data: (this.props.value || []) as AffixMapItem[],
  };

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(next: any) {
    this.setState({ data: next.value || [] });
  }

  emit = (data: AffixMapItem[]) => {
    this.setState({ data });
    this.props.onChange?.(data);
  };

  addItem = () => {
    const data = clone(this.state.data);
    data.push({ value: '', text: '', color: '' });
    this.emit(data);
  };

  removeItem = (index: number) => {
    const data = clone(this.state.data);
    data.splice(index, 1);
    this.emit(data);
  };

  onItemChange = (index: number, name: keyof AffixMapItem, val: string) => {
    const data = clone(this.state.data);
    data[index] = { ...data[index], [name]: val };
    this.emit(data);
  };

  render() {
    return (
      <div>
        <Button
          type='dashed'
          block
          icon={<PlusOutlined />}
          onClick={this.addItem}
          style={{ marginBottom: 8 }}
        >
          Thêm mapping
        </Button>
        {this.state.data.map((item, index) => (
          <Row
            key={index}
            gutter={[8, 8]}
            align='middle'
            style={{ marginBottom: 8 }}
          >
            <Col xs={7}>
              <Input
                placeholder='Value cột phụ thuộc'
                value={item.value}
                onChange={(e) =>
                  this.onItemChange(index, 'value', e.target.value)
                }
              />
            </Col>
            <Col xs={7}>
              <Input
                placeholder='Text hiển thị'
                value={item.text}
                onChange={(e) =>
                  this.onItemChange(index, 'text', e.target.value)
                }
              />
            </Col>
            <Col xs={7}>
              <ColorPicker
                type='sketch'
                small
                color={item.color || '#595959'}
                position='top'
                presetColors={[
                  '#389e0d',
                  '#cf1322',
                  '#1890ff',
                  '#fa8c16',
                  '#722ed1',
                  '#595959',
                ]}
                onChangeComplete={(color: string) =>
                  this.onItemChange(index, 'color', color)
                }
              >
                {item.color || 'Màu'}
              </ColorPicker>
            </Col>
            <Col xs={3}>
              <Button
                danger
                block
                icon={<DeleteOutlined />}
                onClick={() => this.removeItem(index)}
              />
            </Col>
          </Row>
        ))}
      </div>
    );
  }
}

export default AffixMapEditor;
